'use client';
import React, { useRef } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { Lottie, LottieRefCurrentProps } from '@/components/LottieWrapper';
import { useLottieLoader } from '@/lib/useLottieLoader';
import { useGSAP } from '@gsap/react';

const playLottieAnimation = (
  mainRef: React.RefObject<HTMLDivElement | null>,
  ref: React.RefObject<LottieRefCurrentProps | null>,
) => {
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.create({
    trigger: mainRef.current,
    start: 'top center',
    end: '+=200px center',
    animation: gsap.timeline({
      defaults: {
        duration: 2,
        ease: 'none',
      },
    }),
    onEnter: () => {
      ref.current?.setDirection(1);
      ref.current?.play();
      setTimeout(() => {
        ref.current?.pause();
      }, 1000);
    },
    onLeave: () => {},
    onEnterBack: () => {
      ref.current?.setDirection(-1);
      ref.current?.play();
    },
    onLeaveBack: () => {},
  });
};

export const IconLottie: React.FC = () => {
  const ref = useRef<LottieRefCurrentProps>(null);
  const mainRef = useRef<HTMLDivElement>(null);
  const animationData = useLottieLoader('https://lottie.host/2440f9f5-685a-49f9-9233-e1289cc23bf6/prdwBbxXkp.json');

  useGSAP(
    () => {
      playLottieAnimation(mainRef, ref);
    },
    { scope: mainRef },
  );

  return (
    <div ref={mainRef}>
      <Lottie
        animationData={animationData}
        autoplay={false}
        lottieRef={ref}
        loop={false}
        style={{
          width: '100%',
        }}
      />
    </div>
  );
};
